module.exports = __webpack_public_path__ + "static/pdf-icon-4-6a0ccc86ed2d81c4b7bc6096598e0738.png";